import { FuelType } from './FuelType';

export enum BunkerLossReason {
    FuelQualityIssues = 1,
    TechnicalIssues = 2,
    FuelUsedForTankCleaning = 3,
    OtherLossReason = 4,
}

const reasonTexts = {
    [BunkerLossReason.FuelQualityIssues]: 'Fuel quality issues',
    [BunkerLossReason.TechnicalIssues]: 'Technical issues',
    [BunkerLossReason.FuelUsedForTankCleaning]: 'MGO used for fuel tank cleaning',
    [BunkerLossReason.OtherLossReason]: 'Other reason',
};

const reasonTextsReverse = {
    'Fuel quality issues': BunkerLossReason.FuelQualityIssues,
    'Technical issues': BunkerLossReason.TechnicalIssues,
    'MGO used for fuel tank cleaning': BunkerLossReason.FuelUsedForTankCleaning,
    'Other reason': BunkerLossReason.OtherLossReason,
};

export const getBunkerLossReasonTexts = (selectedFuelType?: FuelType): string[] => {
    return selectedFuelType === FuelType.LGO
        ? Object.values(reasonTexts)
        : Object.values(reasonTexts).filter((reason) => reason !== 'MGO used for fuel tank cleaning');
};

export const getBunkerLossReasonText = (bunkerLossReason: BunkerLossReason): string => {
    return reasonTexts[bunkerLossReason];
};

export const getBunkerLossReason = (reasonText: string): BunkerLossReason => {
    return reasonTextsReverse[reasonText];
};
